<span *ngIf="isUserAmbassador">
  <img src="assets/images/profil/crown-ambassador.svg" loading="lazy" fetchpriority="low"><span i18n="@@ambassador.badge.label">Ambassador</span>
</span>
